import { render } from "./ClinicalInformation.vue?vue&type=template&id=76acac92"
import script from "./ClinicalInformation.ts?vue&type=script&lang=js&external"
export * from "./ClinicalInformation.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__